import React, { FC } from 'react'

import { IconEnvironmentProps } from './IconEnvironment.types'
import * as Styled from './styles/IconEnvironment.style'

import { nonThemeableRules } from '../../ruleSet'

const IconEnvironment: FC<IconEnvironmentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconEnvironmentProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconEnvironmentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M147.88 15a4 4 0 0 0-2.81-2.88A89.61 89.61 0 0 0 33.61 118.08Q24 130.69 15.42 144.15a4 4 0 1 0 6.75 4.29q8.11-12.76 17.19-24.71a89.69 89.69 0 0 0 43.27 0 89 89 0 0 0 55.13-40.82A89 89 0 0 0 147.88 15zm-17 63.73a81.1 81.1 0 0 1-50.18 37.21 81.81 81.81 0 0 1-35.91.81 362.17 362.17 0 0 1 68.58-66 4 4 0 1 0-4.75-6.44 370.23 370.23 0 0 0-68.41 65.35 81.6 81.6 0 0 1 100.45-90.4 81.06 81.06 0 0 1-9.75 59.5z' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconEnvironment
